
import React, { useEffect, useState } from 'react';
import {
  BrowserRouter as Router,
  Routes,
  Route,
  Navigate,
  useLocation
} from "react-router-dom";

import './App.css'

import Dashboard from "./Pages/Dashboard/dashboard";
import SignUp from "./Pages/Sign Up/sign_up";
import SignIn from "./Pages/Login/login";
import UserGoals from "./Pages/User Goals/user_goals";

import MealCalendar from "./Pages/Meal Calendar/meal_calendar";
import { useAuth } from './Components/AuthContext/AuthContext'
import Subscription from "./Pages/Subscription/subscription";
import Billing from "./Pages/Billing/billing";
import NutritionistAI from "./Pages/NutritionistAI/ntai";
import ShoppingList from "./Pages/ShoppingList/shopping_list";
import SidebarMenu from './Components/SidebarMenu/SidebarMenu';
import TopPromoComponent from "./Components/TopPromoComponent/TopPromoComponent";
import TopMenu from "./Components/TopMenu/TopMenu";
import Analytics from "./Pages/Analytics/analytics";
import MealDetail from "./Pages/MealDetail/meal_detail";
import ExploreMeals from "./Pages/ExploreMeals/explore_meals";
import AddMeal from "./Pages/AddMeal/AddMeal";
import Settings from "./Pages/Settings/Settings";
import EditMealModal from './Components/EditMeal/EditMeal';
import ProfileAndSettings from './Pages/ProfileAndSettings/profile_and_settings';
import Premium from './Pages/Premium/Premium';
import InActiveUser from './Pages/InActiveUser/inActiveUser';
import PageNotFount from './Pages/PageNotFount/PageNotFount';
import Loading from './Components/Loading/Loading';
import AdminMeals from './Pages/AdminMeals/AdminMeals';
import AdminIngredients from './Pages/AdminIngredients/AdminIngredients';
import PreparingMealPlan from './Components/PreparingMealPlan/PreparingMealPlan';
import AdminIngredientsMerge from './Pages/AdminIngredientsMerge/AdminIngredientsMerge';

function App() {
  const location = useLocation();
  const hide_dashboard_navbar_pages = ['/sign-up', '/login', '/premium', '/ntai', '/admin'];
  const show_dashboard_navbar = !hide_dashboard_navbar_pages.some(path => location.pathname.startsWith(path));
  const [currentUserApp, setCurrentUserApp] = useState(null)
  const [userConfigExistApp, setUserConfigExistApp] = useState(false)
  const [userInfoApp, setUserInfoApp] = useState(null)
  const [has_tokenApp, setHas_tokenApp] = useState(false)
  const [loading, setLoading] = useState(true);  // Loading state
  const [editMeal, setEditMeal] = useState(false)

  const { currentUser, userConfigExist, userInfo, has_token, urlRedirect, setUrlRedirect } = useAuth();

  useEffect(() => {
    if (currentUser && (userConfigExist != null) && userInfo && has_token) {
      setCurrentUserApp(currentUser)
      setUserConfigExistApp(userConfigExist)
      setUserInfoApp(userInfo)
      setHas_tokenApp(has_token)
      setLoading(false)
    } else {
      setLoading(false)
    }

    // set redirect to null once login
    if (currentUserApp && urlRedirect) {
      setUrlRedirect();
    }
  }, [currentUser, userConfigExist, userInfo, has_token])

  // If the info is not here yet forget about the routes, make the app slower in 
  // reloads but it fixes issues such as directly entering a url
  if (loading) {
    return <Loading />;
  }

  return (
    <div className="font_family_inter">
      {/* Loading Component */}
      <div id='loading'>
        <Loading />
      </div>

      <div>
        {/* Top Promo Ad */}
        {show_dashboard_navbar && currentUserApp && userInfoApp && !userInfoApp.active_subscription && <TopPromoComponent />}
        <div className="app-navigation-side-top-menu-div">
          <div>
            {/* Edit Meal */}
            {editMeal ? <EditMealModal setEditMeal={setEditMeal} /> : null}
            {/* Side Menu Bar */}
            {show_dashboard_navbar ? <SidebarMenu /> : null}
          </div>
          <div className="app-right-main-component-all-div">
            {/* Top Menu Bar */}
            {show_dashboard_navbar && currentUserApp && <TopMenu />}
            {
              <Routes>
                <Route path="/" element={(currentUserApp && has_tokenApp) ? ((currentUserApp.emailVerified) ? (!userConfigExistApp ? <UserGoals /> : <Dashboard setEditMeal={setEditMeal} />) : <InActiveUser />) : <Navigate to='/login' />} />

                <Route path="/profile-settings" element={(currentUserApp && has_tokenApp) ? ((currentUserApp.emailVerified) ? (userConfigExistApp ? <ProfileAndSettings /> : <Navigate to='/' />) : <InActiveUser />) : <Navigate to='/login' />} />

                <Route path="/add-meal" element={(currentUserApp && has_tokenApp) ? ((currentUserApp.emailVerified) ? (userConfigExistApp ? <AddMeal /> : <Navigate to='/' />) : <InActiveUser />) : <Navigate to='/login' />} />

                <Route path="/user-config" element={(currentUserApp && has_tokenApp) ? ((currentUserApp.emailVerified) ? (!userConfigExistApp ? <UserGoals /> : <Navigate to='/' />) : <InActiveUser />) : <Navigate to='/login' />} />

                <Route path="/calendar" element={(currentUserApp && has_tokenApp) ? ((currentUserApp.emailVerified) ? (!userConfigExistApp ? <UserGoals /> : <MealCalendar currentUser={currentUserApp} userInfo={userInfoApp} setEditMeal={setEditMeal} />) : <InActiveUser />) : <Navigate to='/login' />} />

                <Route path="/analytics" element={(currentUserApp && has_tokenApp) ? ((currentUserApp.emailVerified) ? (!userConfigExistApp ? <UserGoals /> : <Analytics />) : <InActiveUser />) : <Navigate to='/login' />} />

                <Route path="/ntai/:question" element={(currentUserApp && has_tokenApp) ? ((currentUserApp.emailVerified) ? (!userConfigExistApp ? <UserGoals /> : <NutritionistAI />) : <InActiveUser />) : <Navigate to='/login' />} />

                <Route path="/ntai" element={(currentUserApp && has_tokenApp) ? ((currentUserApp.emailVerified) ? (!userConfigExistApp ? <UserGoals /> : <NutritionistAI />) : <InActiveUser />) : <Navigate to='/login' />} />

                <Route path="/sign-up" element={!currentUserApp ? <SignUp /> : <Navigate to='/' />} />

                <Route path="/login" element={!currentUserApp ? <SignIn /> : <Navigate to={urlRedirect || '/'} />} />

                <Route path="/subscription" element={(currentUserApp && has_tokenApp) ? ((currentUserApp.emailVerified) ? (!userConfigExistApp ? <UserGoals /> : <Subscription user_data={currentUserApp} />) : <InActiveUser />) : <Navigate to='/login' />} />

                <Route path="/billing/overview" element={(currentUserApp && has_tokenApp) ? ((currentUserApp.emailVerified) ? (!userConfigExistApp ? <UserGoals /> : <Billing userInfo={userInfoApp} user_data={currentUserApp} page={'overview'} />) : <InActiveUser />) : <Navigate to='/login' />} />

                <Route path="/billing/payment-methods" element={(currentUserApp && has_tokenApp) ? ((currentUserApp.emailVerified) ? (!userConfigExistApp ? <UserGoals /> : <Billing userInfo={userInfoApp} user_data={currentUserApp} page={'payment_method'} />) : <InActiveUser />) : <Navigate to='/login' />} />

                <Route path="/billing/history" element={(currentUserApp && has_tokenApp) ? ((currentUserApp.emailVerified) ? (!userConfigExistApp ? <UserGoals /> : <Billing userInfo={userInfoApp} user_data={currentUserApp} page={'history'} />) : <InActiveUser />) : <Navigate to='/login' />} />

                <Route path="/billing/cancel" element={(currentUserApp && has_tokenApp) ? ((currentUserApp.emailVerified) ? (!userConfigExistApp ? <UserGoals /> : <Billing userInfo={userInfoApp} user_data={currentUserApp} page={'cancel'} />) : <InActiveUser />) : <Navigate to='/login' />} />

                <Route path="/explore" element={(currentUserApp && has_tokenApp) ? ((currentUserApp.emailVerified) ? (!userConfigExistApp ? <UserGoals /> : <ExploreMeals />) : <InActiveUser />) : <Navigate to='/login' />} />

                <Route path="/ingredient-tracker" element={(currentUserApp && has_tokenApp) ? ((currentUserApp.emailVerified) ? (!userConfigExistApp ? <UserGoals /> : <ShoppingList />) : <InActiveUser />) : <Navigate to='/login' />} />

                <Route path="/meal-details/:mealId" element={(currentUserApp && has_tokenApp) ? ((currentUserApp.emailVerified) ? (!userConfigExistApp ? <UserGoals /> : <MealDetail setEditMeal={setEditMeal} />) : <InActiveUser />) : <Navigate to='/login' />} />

                <Route path="/settings/profile" element={(currentUserApp && has_tokenApp) ? ((currentUserApp.emailVerified) ? (!userConfigExistApp ? <UserGoals /> : <Settings userInfo={userInfoApp} user_data={currentUserApp} page={'profile'} />) : <InActiveUser />) : <Navigate to='/login' />} />

                <Route path="/premium" element={(currentUserApp && has_tokenApp) ? ((currentUserApp.emailVerified) ? (!userConfigExistApp ? <UserGoals /> : <Premium userInfo={userInfoApp} user_data={currentUserApp} />) : <InActiveUser />) : <Navigate to='/login' />} />

                <Route path="/admin/meals" element={(currentUserApp && has_tokenApp) ? ((currentUserApp.emailVerified) ? (!userConfigExistApp ? <UserGoals /> : <AdminMeals userInfo={userInfoApp} user_data={currentUserApp} />) : <InActiveUser />) : <Navigate to='/login' />} />

                <Route path="/admin/ingredients" element={(currentUserApp && has_tokenApp) ? ((currentUserApp.emailVerified) ? (!userConfigExistApp ? <UserGoals /> : <AdminIngredients userInfo={userInfoApp} user_data={currentUserApp} />) : <InActiveUser />) : <Navigate to='/login' />} />

                <Route path="/admin/ingredients/merge" element={(currentUserApp && has_tokenApp) ? ((currentUserApp.emailVerified) ? (!userConfigExistApp ? <UserGoals /> : <AdminIngredientsMerge userInfo={userInfoApp} user_data={currentUserApp} />) : <InActiveUser />) : <Navigate to='/login' />} />

                <Route
                  path="*"
                  element={<PageNotFount />}
                />
              </Routes>
            }

          </div>
        </div>
      </div>
    </div >
  );
}



export default App;
